import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Box, Drawer, List, ListItem, IconButton, Tooltip } from '@mui/material';
import { Mic, Settings, LogOut } from 'lucide-react';
import { logout } from '../../utils/auth.js';
import logo from '../../assets/compagnio_logo.svg';
import { useTranslation } from 'react-i18next';

const MainLayout = ({ user }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Box sx={{ display: 'flex'}}>
      <Drawer
        variant="permanent"
        sx={{
          display: {xs: 'none', md: 'block'},
          width: { md: '48px', xl: '60px' },
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            border: 'none',
            bgcolor: '#F4F4F5',
            width: { md: '48px', xl: '60px' },
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 2,
          },
        }}
      >
        <Box>
          <img src={logo} alt="Compagnio Logo" style={{ width: '100%' }} />
        </Box>
        
        <List sx={{ width: '100%', mt: 2 }}>
          <ListItem sx={{ justifyContent: 'center', py: 0 }}>
            <Tooltip title={t('common.home')} placement="right">
              <IconButton onClick={() => handleNavigation('/')}  color='primary'>
                <Mic strokeWidth={1.5} size={20}/>
              </IconButton>
            </Tooltip>
          </ListItem>
          
          <ListItem sx={{ justifyContent: 'center' }}>
            <Tooltip title={t('common.settings')} placement="right">
              <IconButton onClick={() => handleNavigation('/settings')} color='primary'>
                <Settings strokeWidth={1.5} size={20}/>
              </IconButton>
            </Tooltip>
          </ListItem>
        </List>
        
        <Box sx={{ flexGrow: 1}} />
        
        <IconButton 
          onClick={() => logout()} 
          color="primary"
          sx={{ mb: 1 }}
        >
          <Tooltip title={t('common.logout')} placement="right">
            <LogOut strokeWidth={1.5} size={20}/>
          </Tooltip>
        </IconButton>
      </Drawer>
      
      {/* DASHBOARD CONTAINER */}
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout; 